import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { tryToFetchUserBillingStatus } from '../../actions/actions.export.js';

import Button from '../Button/Button.js'

import {
  tryToCreateTeamStripePortalSession
} from '../../actions/actions.export'

class UserSettingsBillingStatusForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);
  }

  render(){
    const { dispatch, team } = this.props; 
    const state = this.state;

    return (
      <div>
        <p>
          Pattycake billing is handled entirely via Stripe's billing portal.
        </p>
        <p>
          From there, you can manage your payment methods, tax information, cancel your subscription and more.
        </p>
        <Button 
          display={<span>Open Billing Portal &nbsp;<i className="far fa-external-link"/></span>}
          size="large"
          color="success"
          thinking={team.tryingToCreateTeamPortalSession}
          failed={team.failedToCreateTeamPortalSession}
          successful={team.successfullyCreatedTeamPortalSession}
          onClick={e => dispatch(tryToCreateTeamStripePortalSession({
            id: this.props.id
          }))}
          />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  const { team } = state;

  return {
    team
  }
}

export default connect(mapStateToProps)(UserSettingsBillingStatusForm);



// WEBPACK FOOTER //
// ./src/components/TeamSettingsStripePortalLauncher/TeamSettingsStripePortalLauncher.js